import NProgress from 'nprogress';

export const start = () => {
  NProgress.start();
};

export const done = () => {
  NProgress.done();
};
